export const unloadDagForTable = (tableName) =>
    tableName.toLowerCase().includes('fact') ? 'conventional_unload_sales' : 'conventional_unload_meta_table'
